// @flow

import { call, takeEvery, put } from 'redux-saga/effects';
import { type Saga } from 'redux-saga';
import { makeGetRequest } from 'services/request/request';
import { PIT_STATS_REQUEST } from './constant';
import { pitStatsFailure, pitStatsSuccess } from './actions';

export function* pitStatsRequest(data: any): Saga<*> {
  try {
    const {
      payload: { pitNumber },
    } = data;
    const response = yield call(makeGetRequest, `/pit-stats/${pitNumber}`);
    if (response && response.statusCode === 200) {
      yield put(pitStatsSuccess(response.body));
    }
  } catch (error) {
    yield put(pitStatsFailure({ statusCode: error.statusCode, message: error.message }));
  }
}

export default function* pitSaga(): Saga<*> {
  yield takeEvery(PIT_STATS_REQUEST, pitStatsRequest);
}
